import { render, staticRenderFns } from "./GameTurbo.vue?vue&type=template&id=3012ba8a&scoped=true"
import script from "./GameTurbo.vue?vue&type=script&lang=js"
export * from "./GameTurbo.vue?vue&type=script&lang=js"
import style0 from "./game_turbo.scss?vue&type=style&index=0&id=3012ba8a&prod&scoped=true&lang=scss&external"
import style1 from "./GameTurbo.vue?vue&type=style&index=1&id=3012ba8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012ba8a",
  null
  
)

export default component.exports